import React, { useRef, useState } from 'react'
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  ActivityIndicator
} from 'react-native'
import { colorPalette, globalStyles } from '../../../static/styles/global'
import { Ionicons, MaterialIcons, AntDesign } from '@expo/vector-icons'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { usePersonalStore } from '../../../stores/personalInfo'
import moment from 'moment'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import Toast from 'react-native-toast-message'
import Canvas from '../../canvas'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SignatureFormView from '../SignatureFormView'

const GAInformationOnline = ({ navigation, route }) => {
  const {
    essUserOnBoardingKey,
    essUserOnBoardingFormKey,
    values,
    completeOnline,
    a,
    b,
    c,
    e,
    g,
    h,
    total,
    letterUsed
  } = route.params


  const [hasDrawn, setHasDrawn] = useState(false)
  const [signatureDataURL, setSignatureDataURL] = useState('')

  const personalstore = usePersonalStore()
  const intializeStore = useInitializeStore()
  const { loading, postgaonline } = useFormsStore()

  const handlesubmit = async (signatureDataURL: any) => {
    const data = {
      essUserOnBoardingFormKey: essUserOnBoardingFormKey,
      essObKey: essUserOnBoardingKey,
      completeOnline: true,
      essUserKey: intializeStore.initializeData?.userkey,
      entityId: personalstore.personalData?.entityId,
      filingStatus: letterUsed,
      dependentAllowances: values.dependentAllowances ? values.dependentAllowances : null,
      georgiaAdjustmentsAllowance: values?.georgiaAdjustmentsAllowance ? values?.georgiaAdjustmentsAllowance : null,
      additionalWithholding: values.additionalwithholding ? values.additionalwithholding : null,
      totalAllowances: total,
      incomeTaxLiability: Number(values.incomeTaxLiability) || null,
      userState: values.userState ? values.userState : null,
      sign: signatureDataURL
    }
    const response: any = await postgaonline(data)
    if (response?.success === true) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    } else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }




  return (
    <>
      <View style={{ flex: 1 }}>
        <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
          <View style={[globalStyles.horizontalPadGap]}>
            <HomeDetailsHeader
              navLabel="Forms"
              navScreen="OnboardingForms"
              title={'GA Withholding Taxation'}
            />
          </View>
        </View>

        <SignatureFormView
          essUserOnBoardingFormKey={essUserOnBoardingFormKey}
          essUserOnBoardingKey={essUserOnBoardingKey}
          isSubmitting={loading}
          onPrevious={() =>
            navigation.navigate('GaInformationForm', {
              essUserOnBoardingFormKey,
              essUserOnBoardingKey,
              values,
              mode: "online",
            })
          }
          onSubmit={handlesubmit}
        />
      </View>
    </>
  )
}

export default GAInformationOnline
